import React from 'react';
import './AwardsContent.css';
import Container from '@material-ui/core/Container';
// import Awardstab from './Awardstab';
import Awardstabv2 from './Awardstabv2';

function AwardsContent() {
  return (
    <>
        <div className="main-container" id='main'>
            <title>LKM Portal - Awards</title>
            {/* <img src="images/awards/at-new-awards-banner.jpg" alt="banner" className='banner-img'/> */}
            <div className='bannerText-Wrapper'>
                <h1 className='bannerHeading' tabIndex={0}>Prestigious <span>Awards</span></h1>
                <p className='bannerSubheading'>Recognition for excellence in learning and innovation</p>
                </div>
        </div>
        <div className="banner-bar"></div>
        <Container className='awards-container' maxWidth="xl">
           <div className="awards-wrap">
               <p>Over the years LKM has won numerous prestigious awards in the international and national forums for excellence in Learning and Innovation. These awards recognize LKM’s best learning programs, processes as well as strategies, bringing professional accolades to the organization.</p>
           </div>
           {/* <Awardstab /> */}
           <Awardstabv2 />
        </Container>
    </>
  )
}

export default AwardsContent;